import type { PayrollReportId } from '../../data/types';

/** Default lowest year selectable for an annual statutory report. */
const DEFAULT_MIN_REPORT_YEAR = 2000;

/**
 * Lowest year selectable for an annual statutory report. The APIT annual
 * reconciliation supports tax years from 2023 only (ADR-164: the API rejects
 * earlier years), so its picker must not offer them.
 */
export function minReportYear(reportId: PayrollReportId): number {
  return reportId === 'apit_annual' ? 2023 : DEFAULT_MIN_REPORT_YEAR;
}
